// extracted by mini-css-extract-plugin
export default {"infoItem":"styles_infoItem__mSrNL","iconLabel":"styles_iconLabel__pCfx7","label":"styles_label__XdZIt","value":"styles_value__sTvdG"};